"use client"
import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from "@iconify/react";
import { patchApi } from './userType.service';
import { resultMessage } from '../../../../service/apiResult';
import {
    confirmationDialogSx,
    confirmationIconSx,
    confirmationPrimaryButtonSx,
    confirmationSecondaryButtonSx,
    confirmationTextSx,
    confirmationTitleSx,
} from '../../../styles/dialogStyles';

export default function InitiativeStatusModal(props) {

    const { onClose, getUserTypeData, selectedId, selectedStatus, setResponseMsg, setAlert, setOpenAlert, setLoading, ALERT_DURATION, alertClose, setActionError } = props;

    const onSubmit = async (e) => {
        e.preventDefault();
        const statusUpdate = selectedStatus === 'ACTIVE' || selectedStatus === 'Active' ? 'INACTIVE' : 'ACTIVE';
        setLoading(true)
        const res = await patchApi(selectedId, statusUpdate);
        setLoading(false);

        if (!res.success) {
            // Refusals stay on the page until dismissed rather than sliding away in a toast.
            setActionError(resultMessage(res));
            onClose();
            return;
        }

        setActionError('');
        // The endpoint returns the updated persona, not a message, so the wording is ours.
        setResponseMsg(resultMessage(res, 'User persona status updated successfully'));
        setAlert('true');
        setOpenAlert(true);
        setTimeout(() => {
            alertClose();
            getUserTypeData();
            onClose();
        }, ALERT_DURATION);
    };

    return (
        <Box sx={confirmationDialogSx}>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
                <Button onClick={onClose} sx={{ minWidth: 'auto', p: 0.5, color: '#6B7280', borderRadius: '999px' }}>
                    <CloseIcon data-testid="cancel-icon" />
                </Button>
            </Stack>
            <form onSubmit={onSubmit}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                    <Box sx={confirmationIconSx}>
                        <Icon icon="mingcute:warning-line" width="36" height="36" color="#C40000" />
                    </Box>
                    <Typography sx={confirmationTitleSx}>Warning!</Typography>
                    <Typography sx={confirmationTextSx}>Do you want to continue?</Typography>
                    <Stack direction="row" spacing={1.5} justifyContent="center" sx={{ pt: 1 }}>
                        <Button variant="contained" type="submit" sx={confirmationPrimaryButtonSx}>Yes</Button>
                        <Button onClick={onClose} sx={confirmationSecondaryButtonSx}>No</Button>
                    </Stack>
                </Stack>
            </form>
        </Box>
    )
}
